import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchGeoInfo } from 'actions/geoInfo';
import { ParsedGeoInfo } from 'models/geoInfo';

export const useGeoInfo = () => {
  const dispatch = useDispatch();
  const [geoInfo, setGeoInfo] = useState<ParsedGeoInfo | null>(null);

  useEffect(() => {
    const fetchGeoInfoData = async () => {
      const results = await (dispatch(fetchGeoInfo()) as unknown as Promise<ParsedGeoInfo>);

      if (results) {
        setGeoInfo(results);
      }
    };
    fetchGeoInfoData();
  }, [dispatch]);

  return geoInfo;
};
